"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var index_1 = require("../index");

function calculateCapacity(venue) {
  try {
    var lowestCapacity_1 = null;
    var highestCapacity_1 = 0;

    if (Object.values(venue.spaces).length == 0) {
      return {
        min: 0,
        max: 0,
        range: "Requires Inquiry"
      };
    }

    Object.values(venue.spaces).forEach(function (venueSpace) {
      if (lowestCapacity_1 === null || venueSpace.capacity < lowestCapacity_1) {
        lowestCapacity_1 = venueSpace.capacity;
      }

      highestCapacity_1 += venueSpace.capacity;
    });
    return {
      min: lowestCapacity_1,
      max: highestCapacity_1,
      range: lowestCapacity_1 + " \u2013\xA0" + highestCapacity_1
    };
  } catch (error) {
    return {
      min: 0,
      max: 0,
      range: "Requires Inquiry"
    };
  }
}

exports.calculateCapacity = calculateCapacity;

function displayCost(cost) {
  try {
    var currencyString = cost.currency === "USD" ? "$" : cost.currency;
    var costString = "" + currencyString + index_1.numberWithCommas(cost.amount);

    switch (cost.type) {
      case "FIXED":
        break;

      case "HOUR":
        costString = costString + "/hr";
        break;

      case "PERSON":
        costString = costString + "/guest";
        break;

      case "PERSONHOUR":
        costString = costString + "/guest/hr";
        break;

      case "MINIMUM":
        costString = costString + " min";
        break;

      case "TICKET":
        costString = costString + "/ticket";
        break;

      case "PLATE":
        costString = costString + "/plate";
        break;
    }

    return costString;
  } catch (error) {
    return "";
  }
}

exports.displayCost = displayCost;

function estimatePrice(venue, inquiry) {
  try {
    var estimation_1 = {
      total: {
        amount: 0,
        currency: "USD"
      }
    };

    var addCost_1 = function addCost_1(cost) {
      switch (cost.type) {
        case "FIXED":
          estimation_1.total.amount += cost.amount;
          break;

        case "HOUR":
          estimation_1.total.amount += cost.amount * inquiry.length;
          break;

        case "PERSON":
          estimation_1.total.amount += cost.amount * inquiry.guests;
          break;

        case "PERSONHOUR":
          estimation_1.total.amount += cost.amount * inquiry.guests * inquiry.length;
          break;

        case "MINIMUM":
          if (!estimation_1.minimum) {
            estimation_1.minimum = {
              amount: cost.amount,
              currency: "USD"
            };
          } else {
            estimation_1.minimum.amount += cost.amount;
          }

          break;
      }
    };

    Object.keys(venue.spaces).forEach(function (spaceId) {
      var space = venue.spaces[spaceId];

      if (inquiry.spaces[spaceId]) {
        addCost_1(space.startingCost);
      }
    });
    Object.keys(venue.options).forEach(function (optionId) {
      var option = venue.options[optionId];

      if (inquiry.options[optionId]) {
        addCost_1(option.startingCost);
      }
    });
    return estimation_1;
  } catch (error) {
    var emptyEstimation = {
      total: {
        amount: 0,
        currency: "USD"
      }
    };
    return emptyEstimation;
  }
}

exports.estimatePrice = estimatePrice;

exports.getVenueStartingCost = function (venue) {
  try {
    var cheapestCost_1 = null;
    Object.keys(venue.spaces).forEach(function (spaceId) {
      var space = __assign({
        id: spaceId
      }, venue.spaces[spaceId]);

      if (!cheapestCost_1 || space.startingCost.amount < cheapestCost_1.amount) {
        cheapestCost_1 = space.startingCost;
      }
    });
    return cheapestCost_1;
  } catch (error) {
    console.log(error);
    return {
      amount: null,
      currency: "USD",
      type: "FIXED"
    };
  }
};

exports.getVenuePrimaryPhotoUrl = function (venue, tagId) {
  try {
    if (!venue.photos) {
      return null;
    }

    var primaryPhoto = lodash_1.default.find(venue.photos, {
      primary: true,
      tag: tagId || null
    });

    if (primaryPhoto) {
      return primaryPhoto.file.url;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

exports.getOptionTitle = function (option) {
  try {
    var optionIndices = index_1.genIndices("name", index_1.VenueOptionTypes);
    return index_1.VenueOptionTypes[optionIndices[option.subType]].title;
  } catch (error) {
    console.log(error);
    return option.subType;
  }
};

exports.validateVenueSpace = function (venueSpace) {
  var errors = [];

  if (!venueSpace.name) {
    errors.push("name");
  }

  if (!venueSpace.capacity) {
    errors.push("capacity");
  }

  if (!venueSpace.startingCost || !venueSpace.startingCost.amount) {
    errors.push("starting cost");
  }

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors
    };
  } else {
    return {
      valid: true
    };
  }
};

exports.validateVenueOption = function (venueOption) {
  var errors = [];

  if (!venueOption.type) {
    errors.push("type");
  }

  if (!venueOption.subType) {
    errors.push("sub type");
  }

  if (!venueOption.startingCost || !venueOption.startingCost.amount) {
    errors.push("starting cost");
  }

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors
    };
  } else {
    return {
      valid: true
    };
  }
};

exports.validateVenueMenu = function (venueMenu) {
  var errors = [];

  if (!venueMenu.type) {
    errors.push("type");
  }

  if (!venueMenu.name) {
    errors.push("name");
  }

  if (!venueMenu.file || !venueMenu.file.url) {
    errors.push("file");
  }

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors
    };
  } else {
    return {
      valid: true
    };
  }
};

exports.validateVenuePhoto = function (venuePhoto) {
  var errors = [];

  if (!venuePhoto.file || !venuePhoto.file.url) {
    errors.push("file");
  }

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors
    };
  } else {
    return {
      valid: true
    };
  }
};

exports.validateVenue = function (venue) {
  var errors = [];

  if (!venue.name) {
    errors.push("name");
  }

  if (!venue.description) {
    errors.push("description");
  }

  if (!venue.location || !venue.location.city) {
    errors.push("location");
  }

  var validatedSpaces = Object.values(venue.spaces).map(function (space) {
    return exports.validateVenueSpace(space);
  });

  if (lodash_1.default.find(validatedSpaces, {
    valid: false
  })) {
    errors.push("spaces");
  }

  var validatedOptions = Object.values(venue.options).map(function (option) {
    return exports.validateVenueOption(option);
  });

  if (lodash_1.default.find(validatedOptions, {
    valid: false
  })) {
    errors.push("options");
  }

  var validatedMenus = Object.values(venue.menus).map(function (menu) {
    return exports.validateVenueMenu(menu);
  });

  if (lodash_1.default.find(validatedMenus, {
    valid: false
  })) {
    errors.push("spaces");
  }

  var validatedPhotos = Object.values(venue.photos).map(function (photo) {
    return exports.validateVenuePhoto(photo);
  });

  if (lodash_1.default.find(validatedPhotos, {
    valid: false
  })) {
    errors.push("photos");
  }

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors
    };
  } else {
    return {
      valid: true
    };
  }
};